import queryString from 'query-string';
const DEFAULT_PARAMS = {
    mode: 'crop',
    upscale: true,
};
/**
 * Create an image URL for ImageProcessor
 * @param image The image model
 * @param imageParams The image parameters
 * @returns The image URL
 */
export function getImageUrl(image, imageParams) {
    if (!image) {
        return '';
    }
    let params = { ...DEFAULT_PARAMS, ...imageParams };
    if (params.mode === 'crop' || params.mode === 'boxpad' || params.mode === 'pad') {
        params = fixPadParams(params);
    }
    return `${image}?${queryString.stringify(params)}`;
}
function fixPadParams(imageParams) {
    if (!imageParams.height && !!imageParams.width && !!imageParams.heightratio) {
        return {
            ...imageParams,
            height: imageParams.width * imageParams.heightratio,
        };
    }
    else if (!imageParams.width && !!imageParams.height && !!imageParams.widthratio) {
        return {
            ...imageParams,
            width: imageParams.height * imageParams.widthratio,
        };
    }
    else if (!!imageParams.width && !!imageParams.height) {
        return imageParams;
    }
    else {
        return { ...imageParams, mode: 'boxpad' };
    }
}
